export default __webpack_public_path__ + "static/media/PowerButtonClicked.8bff76a1.svg";